import anime from 'animejs';

class MobileMenu {

  constructor(navElement) {
    this.navElement = navElement;
    this.mobileToggle = this.navElement.querySelector('.js-mobile-toggle');
    this.mobileToggleActive = this.navElement.querySelector('.js-mobile-toggle--active');
    this.menuElement = this.navElement.querySelector('#mobile-nav');
    this.menuBackground = this.navElement.querySelector('.mobile-menu-wrapper');

    if ( !this.menuElement ) return;

    let haveChildren = this.menuElement.querySelectorAll('.menu__item--has-children');

    for ( let i = 0; i < haveChildren.length; i++ ) {
      let menuItem = haveChildren[i];

      // Add Dropdown icons for mobile menu's top level menu items
      var mobileDropdown = document.createElement('div');
      mobileDropdown.setAttribute('class', 'menu__dropdown-icon dropdown-icon');
      menuItem.appendChild(mobileDropdown);

      menuItem.addEventListener('click', (event) => {
        if ( event.target.classList.contains('menu__dropdown-icon') ) {
          this._toggleSubmenu(menuItem);
        }

        if ( this.active == true ) {
          this.menuBackground.classList.add('overflow-y-auto');
        }
      });
    }

    let haveSubChildren = this.menuElement.querySelectorAll('.sub-menu__item--has-children');

    for ( let i = 0; i < haveSubChildren.length; i++ ) {
      let menuItem = haveSubChildren[i];

      // Add Dropdown icons for mobile menu's submenu items
      var mobileDropdownSubMenu = document.createElement('div');
      mobileDropdownSubMenu.setAttribute('class', 'sub-menu__dropdown-icon');
      menuItem.appendChild(mobileDropdownSubMenu);

      menuItem.addEventListener('click', (event) => {
        if ( event.target.classList.contains('sub-menu__dropdown-icon') ) {
          this._toggleSubmenuDepthOne(menuItem);
        }
      });
    }

    this.active = false;

    this.animating = false;

    this._setButtonTimeline();
    this._setMenuTimeline();

    this.mobileToggle.addEventListener('click', () => {
      this._toggleButton();
      this._toggleMenu();
      this._toggleBackground();
    });

    this.mobileToggleActive.addEventListener('click', () => {
      this._toggleButton();
      this._toggleMenu();
      this._toggleBackground();
    });
  }

  _toggleSubmenu(menuElement) {
    let submenu = menuElement.querySelector('.sub-menu--depth-0');

    if ( submenu.classList.contains('sub-menu--active') ) {
      let animateDropdownShut = anime.timeline({
        autoplay: false,
        loop: false,
        duration: 200,
        easing: 'easeInOutQuad',
      })
      .add({
        targets: submenu,
        height: '0px',
        begin: () => {
          menuElement.classList.remove('menu-item-has-children--active');
        },
        complete: () => {
          submenu.classList.remove('sub-menu--active');
          submenu.style.height = 'auto';
        },
      }, 0)
      .add({
        targets: menuElement,
        marginBottom: 0,
      }, 0);

      animateDropdownShut.play();
    } else {
      let submenuHeight = submenu.offsetHeight;
      this.active = true;

      let animateDropdownOpen = anime.timeline({
        autoplay: false,
        active: true,
        loop: false,
        duration: 200,
        easing: 'easeInOutQuad',
      })
      .add({
        targets: submenu,
        height: ['0px', submenuHeight + 'px'],
        begin: () => {
          submenu.classList.add('sub-menu--active');
          menuElement.classList.add('menu-item-has-children--active');
        },
      }, 0)
      .add({
        targets: menuElement,
        marginBottom: submenuHeight,
      }, 0);

      animateDropdownOpen.play();
    }
  }

  _toggleSubmenuDepthOne(menuElement) {
    let submenuDepthOne = menuElement.querySelector('.sub-menu--depth-1');
    let submenuDepthOneHeight = submenuDepthOne.offsetHeight;
    let submenu = menuElement.parentElement;
    let submenuItem = submenu.closest('.menu__item');
    let submenuHeight = window.getComputedStyle(submenu, null).height;

    if ( submenuDepthOne.classList.contains('sub-menu--active') ) {
      let animateDropdownShut = anime.timeline({
        autoplay: false,
        loop: false,
        duration: 200,
        easing: 'easeInOutQuad',
      })
      .add({
        targets: submenuDepthOne,
        height: '0px',
        begin: () => {
          menuElement.classList.remove('menu-item-has-children--active');
        },
        complete: () => {
          submenuDepthOne.classList.remove('sub-menu--active');
          submenuDepthOne.style.height = 'auto';
        },
      }, 0)
      .add({
        targets: menuElement,
        marginBottom: 0,
      }, 0)
      .add({
        targets: submenu,
        height: ['0px', (+parseInt(submenuHeight)) - submenuDepthOneHeight + 'px'],
      }, 0)
      .add({
        targets: submenuItem,
        marginBottom: (+parseInt(submenuHeight)) - submenuDepthOneHeight,
      }, 0);

      animateDropdownShut.play();
    } else {
      let animateDropdownOpen = anime.timeline({
        autoplay: false,
        loop: false,
        duration: 200,
        easing: 'easeInOutQuad',
      })
      .add({
        targets: submenuDepthOne,
        height: ['0px', submenuDepthOneHeight + 'px'],
        begin: () => {
          submenuDepthOne.classList.add('sub-menu--active');
          menuElement.classList.add('menu-item-has-children--active');
        },
      }, 0)
      .add({
        targets: menuElement,
        marginBottom: submenuDepthOneHeight,
      }, 0)
      .add({
        targets: submenu,
        height: ['0px', (+submenuDepthOneHeight) + (+parseInt(submenuHeight)) + 'px'],
      }, 0)
      .add({
        targets: submenuItem,
        marginBottom: (+submenuDepthOneHeight) + (+parseInt(submenuHeight)),
      }, 0);

      animateDropdownOpen.play();
    }
  }

  _setButtonTimeline() {
    let duration = 200;

    this.buttonTimeline = anime.timeline({
      easing: 'easeInOutQuad',
      duration: duration,
      autoplay: false,
      loop: false,
    }, 0)
    .add({
      targets: '.mobile-menu__toggle-bar--first',
      translateY: 20,
      opacity: 0,
      duration: duration / 2,
    }, 0)
    .add({
      targets: '.mobile-menu__toggle-bar--second',
      rotate: '45deg',
      duration: duration,
    }, 0)
    .add({
      targets: '.mobile-menu__toggle-bar--third',
      translateY: 20,
      opacity: 0,
      duration: duration,
    }, 0)
    .add({
      targets: '.mobile-menu__toggle-bar--first',
      translateY: 11,
      opacity: 1,
      rotate: '315deg',
      duration: duration * 1.5,
    }, '-=' + duration / 2);
  }

  _setMenuTimeline() {
    let duration = 350;

    this.menuTimeline = anime.timeline({
      easing: 'easeOutQuad',
      duration: duration,
      autoplay: false,
      loop: false,
    }, 0)
    .add({
      targets: this.menuElement,
      translateX: ['100%', 0],
      opacity: [0, 1],
      begin: () => {
        this.menuElement.style.visibility = 'visible';
      },
    }, 0);
  }

  _toggleButton() {

    if ( this.buttonTimeline.began ) {
      this.buttonTimeline.reverse()

      if (this.buttonTimeline.progress === 100 && this.buttonTimeline.direction === 'reverse') {
        this.buttonTimeline.completed = false
      }
    }

    this.buttonTimeline.play();
  }

  _toggleMenu() {

    if ( this.menuTimeline.began ) {
      this.menuTimeline.reverse()

      if (this.menuTimeline.progress == 100 && this.menuTimeline.direction == 'reverse') {
        this.menuTimeline.completed = false
      }
    }

    this.menuTimeline.play();
  }

  _toggleBackground() {
    this.menuBackground.classList.toggle('mobile-menu-wrapper--active');
    document.body.classList.toggle('lock-scroll');
  }

}

export default MobileMenu;



// WEBPACK FOOTER //
// ./scripts/components/MobileMenu.js